const config = {
    // headurl: '', //'http://10.1.1.203:32373',
    // headurl: 'http://10.1.1.203:32373', //'http://10.1.1.203:32373',
    // headurl: 'https://kis.hupdev.hyperup.ru/', //'http://10.1.1.203:32373',
    // headurl: 'http://0.0.0.0:32373', //'http://10.1.1.203:32373',
    // headurl: 'http://10.1.1.203:31432',
    headurl: 'https://kis.hyperup.ru'
};
export default config;
